var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0581 2.74142C17.252 2.62479 17.4835 2.5878 17.7041 2.63821C17.9247 2.68862 18.1171 2.82252 18.2411 3.01179L19.1074 4.33304C19.2203 4.50564 19.2686 4.71259 19.2438 4.91736C19.219 5.12212 19.1226 5.31153 18.9717 5.45217L18.9691 5.45567L18.9569 5.46704L18.907 5.51342L18.7101 5.70154C17.6208 6.75824 16.5644 7.84843 15.5426 8.97054C13.6202 11.0845 11.3374 13.8513 9.80086 16.5358C9.37211 17.2848 8.32473 17.4458 7.70348 16.7992L2.02911 10.9034C1.94779 10.8189 1.8843 10.7189 1.8424 10.6093C1.8005 10.4998 1.78106 10.3829 1.78522 10.2657C1.78938 10.1485 1.81707 10.0333 1.86663 9.92701C1.9162 9.82071 1.98663 9.72546 2.07373 9.64692L3.78873 8.09992C3.93945 7.96404 4.1327 7.88477 4.33541 7.87567C4.53813 7.86657 4.73771 7.92821 4.89998 8.05004L7.79536 10.2209C12.3182 5.76104 14.8829 4.04954 17.0581 2.74142Z",
    fill: "#1CC743"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.1420ca5b42202b5e5bf906dcb6771e30.svg";
export { ForwardRef as ReactComponent };